import {createFileRoute} from "@tanstack/react-router"
import {Invest} from "@/components/invest/Invest.tsx";
import {PoolId} from "@/redux/poolSlice.ts";

export const Route = createFileRoute("/_mainLayout/invest/$code/$year/$month/")({
  component: RouteComponent,
});

function RouteComponent() {
  const {code, year, month} = Route.useParams()
  return (
    <Invest poolId={{code, month: parseInt(month), year: parseInt(year)} as PoolId}/>
  );
}
